import { useMemo, useState } from 'react'

//* HOC's
import { withUIContext } from 'context'

//* Styles
import InformativeSliderGallerySecondaryStyle from './style'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'
import Image from 'components/common/Image'
import CustomLink from 'components/common/CustomLink'

const InformativeSliderGallerySecondary = ({ slides, first, winWidth }) => {
	//! States
	const [activeIndex, setActiveIndex] = useState(0)

	const storeInfo = useMemo(() => {
		return slides.map((item, index) => {
			return (
				<div key={index} className={`info-content ${activeIndex === index ? 'active' : ''}`}>
					<div className='main-content'>
						<Text className={'h6 font-soundscape-bold info-number'}>{`${index + 1}`.padStart(2, 0)}</Text>
						<Text className={'h4 font-ping-bolder info-title'}>{item.title}</Text>
						<Text className={'p pS font-ping-medium info-description'}>{item.description}</Text>
						{item.second_description && (
							<div className={'tip-wrap'}>
								<Icon className={'h4 info-tip-icon'} name={'tip'} />
								<Text className={'p pS font-ping-bolder info-tip'}>{item.second_description}</Text>
							</div>
						)}
						{item.link && (
							<CustomLink className={`learn-more ${!!item.second_description ? 'has-space' : ''}`} url={item.link}>
								<Text className={'p pS font-ping-bolder underline'} text={'learnMore'} />
							</CustomLink>
						)}
					</div>
				</div>
			)
		})
	}, [slides, activeIndex])

	const storeImage = useMemo(() => {
		return slides.map((item, index) => {
			const prevSlideClass = activeIndex > index ? 'prev-slide' : ''
			const nextSlideClass = activeIndex < index ? 'next-slide' : ''

			return (
				<Image
					key={index}
					className={`slide-info-image ${activeIndex === index ? 'active' : ''} ${prevSlideClass} ${nextSlideClass}`}
					src={item.large_image.url}
					alt={item.large_image.alt}
				/>
			)
		})
	}, [slides, activeIndex])

	const storePagination = useMemo(() => {
		return slides.map((item, index) => {
			return <span key={index} onClick={() => setActiveIndex(index)} className={`dot ${activeIndex === index ? 'active' : ''}`}></span>
		})
	}, [slides, activeIndex])

	return (
		<Container section full first={first}>
			<InformativeSliderGallerySecondaryStyle>
				<div className={'info-wrap'}>
					{storeInfo}
					{winWidth < 1280 && (
						<div className={'arrows-wrap'}>
							<Icon
								className={`h5 left-arrow ${activeIndex === 0 ? 'disable' : ''}`}
								onClick={() => setActiveIndex(activeIndex - 1)}
								name={'arrow'}
							/>
							<Icon
								onClick={() => setActiveIndex(activeIndex + 1)}
								className={`h5 right-arrow ${activeIndex === slides.length - 1 ? 'disable' : ''}`}
								name={'arrow'}
							/>
						</div>
					)}
				</div>
				<div className={'gallery-wrap'}>
					{storeImage}
					<div className='pagination-wrap'>{storePagination}</div>
				</div>
				{winWidth >= 1280 && (
					<div className={'arrows-wrap'}>
						<Icon
							className={`h5 left-arrow ${activeIndex === 0 ? 'disable' : ''}`}
							onClick={() => setActiveIndex(activeIndex - 1)}
							name={'arrow'}
						/>
						<Icon
							onClick={() => setActiveIndex(activeIndex + 1)}
							className={`h5 right-arrow ${activeIndex === slides.length - 1 ? 'disable' : ''}`}
							name={'arrow'}
						/>
					</div>
				)}
			</InformativeSliderGallerySecondaryStyle>
		</Container>
	)
}

export default withUIContext(InformativeSliderGallerySecondary, ['winWidth'])
